var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H21",
    stroke: "#202E5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 5C10.9422 5 10.8468 5.03951 10.7765 5.10983C10.7062 5.18016 10.6667 5.27554 10.6667 5.375V6.66667H9.375C9.27554 6.66667 9.18016 6.70618 9.10983 6.7765C9.03951 6.84683 9 6.94221 9 7.04167V8.95833C9 9.05779 9.03951 9.15317 9.10983 9.2235C9.18016 9.29382 9.27554 9.33333 9.375 9.33333H10.6667V10.625C10.6667 10.7245 10.7062 10.8198 10.7765 10.8902C10.8468 10.9605 10.9422 11 11.0417 11H12.9583C13.0578 11 13.1532 10.9605 13.2235 10.8902C13.2938 10.8198 13.3333 10.7245 13.3333 10.625V9.33333H14.625C14.7245 9.33333 14.8198 9.29382 14.8902 9.2235C14.9605 9.15317 15 9.05779 15 8.95833V7.04167C15 6.94221 14.9605 6.84683 14.8902 6.7765C14.8198 6.70618 14.7245 6.66667 14.625 6.66667H13.3333V5.375C13.3333 5.27554 13.2938 5.18016 13.2235 5.10983C13.1532 5.03951 13.0578 5 12.9583 5H11.0417Z",
    fill: "#202E5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.6875V16.9375C10.1333 16.625 10.72 16 12 16C13.28 16 13.8667 16.625 14 16.9375V21",
    stroke: "#202E5F",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingHospital);
export default __webpack_public_path__ + "static/media/building-hospital.12aba309b61c1129b305db2d299a2fd5.svg";
export { ForwardRef as ReactComponent };